import React, { useEffect, useState } from 'react';
import Select from 'react-select';

import { retrieveAllSystemUserPersons } from '../../services/PersonService';
import { notifyClientCreationRequest } from '../../services/ClientService';

import { SaveButton } from '../common/button/save-button/SaveButton';

import './Notification.css';

export const Notification = ({ context, navigateTo, showToaster, setSpinnerText, clientExtRef }) => {
  const [staffMembers, setStaffMembers] = useState([]);
  const [selectedStaffMember, setSelectedStaffMember] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Users');
      const [data, error] = await retrieveAllSystemUserPersons(context.username);
      if (data) {
        if (data.responseStatus === 'Success') {
          const formattedUsers = data.viewAllPersonSystemUserVOs.map((user) => ({
            value: user,
            label: user.name,
          }));
          setStaffMembers(formattedUsers);
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context.username, showToaster]);

  const handleStaffSelection = (selectedStaffMemberOption) => {
    setSelectedStaffMember(selectedStaffMemberOption);
  };

  // eslint-disable-next-line quotes
  const sendNotificationTitle = selectedStaffMember === null ? "Don't Send Notification" : 'Send Notification';

  const handleNotificationClick = async () => {
    setSpinnerText('Sending Notification');
    // eslint-disable-next-line quotes
    if (sendNotificationTitle === "Don't Send Notification") {
      navigateTo('clientsSearch');
    } else {
      let notificationRequest = {
        clientExternalReference: clientExtRef,
        personToNotifyExternalReference: selectedStaffMember?.value?.externalReference,
      };

      const [data, error] = await notifyClientCreationRequest(context.username, notificationRequest);
      if (data) {
        if (data.responseStatus === 'Success') {
          navigateTo('clientsSearch');
          showToaster({
            responseStatus: 'Success',
            responseMessage: 'Notification Sent',
          });
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }

      setSpinnerText(null);
    }
  };

  return (
    <div className="notification-container">
      <p className="notification-paragraph">
        Please choose a staff member who is responsible for filling in the locator information.
      </p>
      <div className="notification-input-container">
        <label className={'input-label-xsm'}>Send Notification To:</label>
        <Select
          options={staffMembers}
          isClearable
          closeMenuOnSelect={true}
          onChange={handleStaffSelection}
          value={selectedStaffMember}
          classNamePrefix="notification-select"
          menuPortalTarget={document.body}
          menuPosition="fixed"
          styles={{
            menuPortal: (base) => ({
              ...base,
              zIndex: 9999,
            }),
          }}
        />
      </div>
      <div className="button-create-container">
        <SaveButton
          title={sendNotificationTitle}
          textColor={'#ffffff'}
          color={'#6F8695'}
          border={'1px solid #6F8695'}
          onClick={handleNotificationClick}
        />
      </div>
    </div>
  );
};
